import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import { orange } from '@material-ui/core/colors';

var RESEND_COOLDOWN_SECONDS = 60;

/**
 * OtpForm — rendered in place of the login form when the auth proxy
 * returns status: 'MFA_REQUIRED'. Manages a 60-second countdown
 * before the resend button becomes active.
 *
 * Props:
 *   pendingAuthToken  {string}   opaque token from the auth proxy
 *   maskedEmail       {string}   e.g. "u***@example.com"
 *   loading           {bool}
 *   error             {string|null}
 *   resent            {bool}     true when OTP_RESENT was received
 *   onVerify          {fn(pendingAuthToken, otp)}
 *   onResend          {fn(pendingAuthToken)}
 *   onCancel          {fn()}
 */
export default class OtpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: '',
      secondsLeft: RESEND_COOLDOWN_SECONDS,
      canResend: false,
    };
    this._timer = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResend = this.handleResend.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this);
    this.startCountdown = this.startCountdown.bind(this);
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    if (this._timer) {
      clearInterval(this._timer);
    }
  }

  startCountdown() {
    var self = this;
    if (self._timer) {
      clearInterval(self._timer);
    }
    self.setState({ secondsLeft: RESEND_COOLDOWN_SECONDS, canResend: false });
    self._timer = setInterval(function() {
      self.setState(function(prev) {
        var next = prev.secondsLeft - 1;
        if (next <= 0) {
          clearInterval(self._timer);
          return { secondsLeft: 0, canResend: true };
        }
        return { secondsLeft: next };
      });
    }, 1000);
  }

  handleOtpChange(e) {
    this.setState({ otp: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    var otp = this.state.otp;
    if (!otp) return;
    this.props.onVerify(this.props.pendingAuthToken, otp);
  }

  handleResend() {
    this.props.onResend(this.props.pendingAuthToken);
    this.startCountdown();
  }

  render() {
    var props = this.props;
    var state = this.state;
    var verifyButtonStyle = props.verifyButtonStyle || {
      backgroundColor: orange[700],
      color: '#fff',
      height: '50px',
      fontWeight: 'bold',
      borderRadius: '10px',
    };

    return (
      <div id="otpCard">
        <center>
          <h3 style={{ marginBottom: '8px' }}>Two-Factor Authentication</h3>
        </center>
        <p style={{ textAlign: 'center', color: '#555', marginTop: 0 }}>
          A verification code was sent to{' '}
          <strong>{props.maskedEmail}</strong>
        </p>

        {props.error && (
          <p
            style={{
              color: 'red',
              textAlign: 'center',
              fontSize: '14px',
            }}
          >
            {props.error}
          </p>
        )}

        {props.resent && (
          <p
            style={{
              color: 'green',
              textAlign: 'center',
              fontSize: '14px',
            }}
          >
            A new code has been sent.
          </p>
        )}

        <form onSubmit={this.handleSubmit}>
          <TextField
            placeholder="Enter verification code"
            label="Verification Code"
            value={state.otp}
            name="otp"
            onChange={this.handleOtpChange}
            fullWidth
            variant="outlined"
            autoFocus
          />
          <br />
          <br />

          {props.loading ? (
            <center>
              <CircularProgress />
            </center>
          ) : (
            <Button
              variant="contained"
              size="large"
              style={verifyButtonStyle}
              fullWidth
              type="submit"
            >
              Verify
            </Button>
          )}

          <br />
          <br />

          <center>
            {state.canResend ? (
              <Button
                size="large"
                variant="text"
                onClick={this.handleResend}
                disabled={props.loading}
              >
                Resend Code
              </Button>
            ) : (
              <p
                style={{
                  color: '#888',
                  fontSize: '13px',
                  margin: '8px 0',
                }}
              >
                Resend available in {state.secondsLeft}s
              </p>
            )}
            <Button
              size="small"
              variant="text"
              onClick={props.onCancel}
              style={{ display: 'block', margin: '4px auto 0' }}
            >
              Back to Login
            </Button>
          </center>
        </form>
      </div>
    );
  }
}
